import { Util } from '@common/utils/util';
import { IDeepCopy } from '@common/interfaces/i-deep-copy';
import { ViewStateRecordsAlias } from "@common/services/layout-state";

export class ViewStateDef implements IDeepCopy<ViewStateDef> {

    public Guid: string = null;
    public Title: string = null;
    public Current: boolean = false;

    private selected: boolean = false;
    public get Selected(): boolean {
        return this.selected;
    }
    public set Selected(value: boolean) {
        if (value != this.selected) {
            this.selected = value;
            if (this.OnChange) {
                this.OnChange(this.selected);
            }
        }
    }
    
    public OnChange: (value: boolean) => any;

    constructor(guid: string, title: string) {
        this.Guid = guid;
        this.Title = title;
    }

    public toJSON() {
        return this.Guid;
    }

    public deepCopy(): ViewStateDef {
        let ret = new ViewStateDef(this.Guid, this.Title);
        ret.Selected = this.Selected;
        ret.Current = this.Current;
        return ret;
    }
}
